import { Container, Divider, Spacer } from '@cleartrip/ct-design-components'
import { Stencil } from '@/components/common/Stencil'
import React, { memo } from 'react'

const LoaderCard = memo(() => (
    <Container className="mb-4 p-relative" >
        <Container 
            className="br-12 pt-3 pb-3 px-3 ba-solid p-absolute" 
            css={{ 
                borderColor: '#e6e6e6',
                backgroundColor: '#ffffff',
                width: '434px',
                height: '147px',
                zIndex: 1
            }}
        >
            <Container className="mb-3 br-4">
                <Stencil shimmer className="br-2" height="20px" width="94px" />
            </Container>
            
            <Container className="mb-3">
                <Stencil shimmer className="br-8" height="52px" width="410px" />
            </Container>
            
            <Container>
                <Stencil shimmer className="br-4" height="20px" width="410px" />
            </Container>
        </Container>
        <Container >
            <Stencil shimmer className="br-12" height="183px" width="434px"  borderRadius={12}/>
        </Container>
    </Container>
))

function IntlRoundTripTuppleLoader() {
    return (
        <Container className="flex-1 flex mt-6">
            <Container className="w-50p pr-2">
                <LoaderCard />
                <LoaderCard />
                <LoaderCard />
            </Container>
            <Container className="w-50p pl-3">
                <LoaderCard />
                <LoaderCard />
                <LoaderCard />
            </Container>
        </Container>
    )
}

export default IntlRoundTripTuppleLoader